import gql from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';

import { DefaultArg, DefaultApiResponse } from '@libs/graphql';

type Networks = {
  bitnetFee: number;
  blockchainFee?: number;
  networkIconUrl?: string;
  networkCode?: string;
  networkId: number;
  networkName?: string;
  blockchainFeeInUsdt?: number;
};

export type GetCryptoWithdrawalFeesRes = {
  assetCode: string;
  assetIconUrl?: string;
  assetName: string;
  price?: string;
  networks?: Networks[];
};

type GetCryptoWithdrawalFeesArgs = {
  take?: number;
  skip?: number;
  term?: string;
};

export type GetCryptoWithdrawalFeesResponse = {
  getCryptoWithdrawalFees: DefaultApiResponse<GetCryptoWithdrawalFeesRes[]>;
};
export const getCryptoWithdrawalFeesQuery: TypedDocumentNode<
  GetCryptoWithdrawalFeesResponse,
  DefaultArg<GetCryptoWithdrawalFeesArgs>
> = gql`
  query getCryptoWithdrawalFees($record: GetWithdrawalFeesRecord) {
    getCryptoWithdrawalFees(record: $record) {
      assetCode
      assetIconUrl
      assetName
      price
      networks {
        bitnetFee
        blockchainFee
        networkIconUrl
        networkCode
        networkId
        networkName
        blockchainFeeInUsdt
      }
    }
  }
`;
